// extracted by mini-css-extract-plugin
module.exports = {"content-type":"styles_content-type__35_0m"};